import React, { useEffect } from "react";
import "./works.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSearch,
  faShoppingCart,
  faCreditCard,
  faBoxOpen,
  faTruck,
  faSmile
} from "@fortawesome/free-solid-svg-icons";
import { Helmet } from "react-helmet";


const steps = [
  {
    icon: faSearch,
    title: "Browse Products",
    description: "Explore a wide range of trending and high-quality items tailored to your style."
  },
  {
    icon: faShoppingCart,
    title: "Add to Cart",
    description: "Found what you like? Add it to your cart with one click — simple and quick."
  },
  {
    icon: faCreditCard,
    title: "Secure Checkout",
    description: "Choose your preferred payment method and complete your order securely."
  },
  {
    icon: faBoxOpen,
    title: "Packaging",
    description: "We carefully prepare your order and pack it with care and quality control."
  },
  {
    icon: faTruck,
    title: "Fast Delivery",
    description: "Your order is shipped through trusted partners — track it all the way."
  },
  {
    icon: faSmile,
    title: "Enjoy Your Purchase",
    description: "Receive your product, enjoy it, and don’t forget to rate your experience!"
  }
];

export default function Works() {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>SHOP.CO | How It Works</title>
        <meta
          name="description"
          content="Learn how SHOP.CO works. From browsing products to advanced filtering, checkout, and fast delivery — discover the full shopping journey."
        />

        <link
          rel="canonical"
          href="https://shop-co-roan.vercel.app/company/works/"
        />
      </Helmet>
      <div className="works-page">
        <h1 className="works-title">How Shopping Works</h1>
        <p className="works-subtitle">
          From browsing to receiving your item — a seamless eCommerce journey.
        </p>

        <div className="works-steps">
          {steps.map((step, index) => (
            <div key={index} className="works-step">
              <div className="step-icon">
                <FontAwesomeIcon icon={step.icon} />
              </div>
              <div className="step-info">
                <h3>{step.title}</h3>
                <p>{step.description}</p>
              </div>
              {index < steps.length - 1 && <div className="step-arrow">→</div>}
            </div>
          ))}
        </div>
      </div>
    </>
  );
}
